import { environment } from "../../../environments/environment";
import { UserRole } from "../enums/role.enum";
import { SidebarItem } from "../models/sidebar-item.model";

// Tenant sidebar items
export const TENANT_SIDEBAR_ITEMS = [
  {
    label: 'Dashboard',
    route: '/dashboard',
    icon: 'bi bi-house',
    section: 'Main'
  },
  {
    label: 'Operation Management',
    icon: 'bi bi-collection',
    section: 'Management',
    children: [
      { label: 'User Management', route: '/user-management', icon: 'bi bi-person' },
      { label: 'Role', route: '/role-management', icon: 'bi bi-file-person' },
      { label: 'Department Management', route: '/department-management', icon: 'bi bi-diagram-2' },
      { label: 'Form Management', route: '/form-management', icon: 'bi bi-file-earmark-text' },
      { label: 'Location Hierarchy', route: '/location-hierarchy', icon: 'bi bi-diagram-3' },
      { label: 'Approver Setup', route: '/approver-setup', icon: 'bi bi-person-check' },
      { label: 'Approval Groups', route: '/approver-group', icon: 'bi bi-people' },
      { label: 'Master Data Management', route: '/master-data-management', icon: 'bi bi-database' },
      // { label: 'FAD Users', route: '/fad-users', icon: 'bi bi-people' },
      // { label: 'Plan Management', route: '/plan-management', icon: 'bi bi-cash-coin' },
      // { label: 'Billing Management', route: '/billing-management', icon: 'bi bi-receipt' },
      {
        label: 'Audit Trail',
        route: '/audit-log',
        icon: 'bi bi-journal-text'
      },
      {
        label: 'Advanced Search Setup',
        route: '/advanced-search-setup',
        icon: 'bi bi-search'
      },
      {
        label: 'User Ebs Information',
        route: '/user-ebs-information',
        icon: 'bi bi-search'
      },
    ]
  },
  {
    label: 'Create New Form',
    route: '/create-new-form',
    icon: 'bi bi-plus-lg',
    section: 'Main'
  },
  {
    label: 'All Forms',
    route: '/all-forms',
    icon: 'bi bi-card-list',
    section: 'Main'
  },
  {
    label: 'My Forms',
    route: '/my-forms',
    icon: 'bi bi-list-task',
    section: 'Main'
  },
  {
    label: 'Forms to Review',
    route: '/review-forms',
    icon: 'bi bi-clipboard-check',
    section: 'Main'
  },
  {
    label: 'Review History',
    route: '/form-history',
    icon: 'bi bi-clock-history',
    section: 'Main'
  },
  {
    label: 'Advanced Search',
    route: '/advanced-search',
    icon: 'bi bi-search',
    section: 'Tools'
  },
  {
    label: 'Customization',
    route: '/customization',
    icon: 'bi bi-sliders',
    section: 'Tools'
  },
  {
    label: 'Template Manager',
    route: environment.templateManagerUrl,
    icon: 'bi bi-file-earmark-text',
    section: 'Tools'
  }
];

// Admin sidebar items
export const ADMIN_SIDEBAR_ITEMS = [
  {
    label: 'Dashboard',
    route: '/admin/dashboard',
    icon: 'bi bi-house',
    section: 'Main'
  },
  {
    label: 'Tenant Management',
    route: '/admin/tenant-management',
    icon: 'bi bi-building',
    section: 'Management'
  },
  {
    label: 'Plan Management',
    route: '/admin/plan-management',
    icon: 'bi bi-cash-coin',
    section: 'Management'
  },
  {
    label: 'User Management',
    route: '/admin/admin-user-management',
    icon: 'bi bi-person',
    section: 'Management'
  },
  {
    label: 'Billing Management',
    route: '/admin/billing-management',
    icon: 'bi bi-receipt',
    section: 'Management'
  },
  {
    label: 'Audit Trail',
    route: '/admin/admin-audit-log',
    icon: 'bi bi-journal-text',
    section: 'Management'
  }
];

// Function to get sidebar items dynamically based on current user state
export function getSidebarItems(): SidebarItem[] {
  const token = localStorage.getItem('token');
  const subdomain = 'dmflow'; // Default subdomain for local development; replace with dynamic logic as needed

  // const hostname = window.location.hostname;
  // let subdomain: string;
  // if (hostname === 'localhost' || hostname.startsWith('127.0.0.1')) {
  //   subdomain = 'dmflow'; // default for local
  // } else {
  //   subdomain = hostname.split('.')[0];
  // }
  const appName = localStorage.getItem('appName') || 'dm_flow';
  const isAdmin = localStorage.getItem('super_admin') === '/admin';

  const storedRoleRaw = localStorage.getItem('selectedRole');
  const storedRole = storedRoleRaw ? JSON.parse(storedRoleRaw) : null;
  const storedRoleID = storedRole?.role_id;

  // Get appropriate sidebar items based on user type
  const RAW_SIDEBAR_ITEMS = isAdmin ? ADMIN_SIDEBAR_ITEMS : TENANT_SIDEBAR_ITEMS;

  return RAW_SIDEBAR_ITEMS.map(item => {
    if (item.label === 'Template Manager' && token) {
      return new SidebarItem({
        ...item,
        route: `${item.route}?token=${encodeURIComponent(token)}&appName=${encodeURIComponent(appName)}&roleID=${encodeURIComponent(storedRoleID)}&subdomain=${encodeURIComponent(subdomain)}`
      });
    }
    return new SidebarItem(item);
  });
}

// Legacy export for backward compatibility (deprecated - use getSidebarItems() instead)
export const SIDEBAR_ITEMS: SidebarItem[] = getSidebarItems();

